module.exports = __webpack_public_path__ + "media/images/list-solid-ba97a0e651f1b6e3a608dbe772d0e13b.svg";